module.exports = __webpack_public_path__ + "img/icon-pull.03e6d7a3.svg";